import { render, staticRenderFns } from "./PricingBlock.vue?vue&type=template&id=bb47ac9e&"
import script from "./PricingBlock.vue?vue&type=script&lang=js&"
export * from "./PricingBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports